<template>
    <div v-if="show" class="modal-overlay" @click.self="$emit('close')">
        <div class="modal-container edit-company-modal">
            <div class="modal-header">
                <h2>Modifier les informations</h2>
                <button class="close-modal-btn" @click="$emit('close')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>

            <div class="modal-body">
                <!-- Onglets de navigation -->
                <div class="form-tabs">
                    <button :class="['tab-btn', { active: activeTab === 'general' }]" @click="activeTab = 'general'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 21h18"></path>
                            <path d="M5 21V7l8-4v18"></path>
                            <path d="M19 21V11l-6-4"></path>
                        </svg>
                        Entreprise
                    </button>
                    <button :class="['tab-btn', { active: activeTab === 'contact' }]" @click="activeTab = 'contact'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                        </svg>
                        Contact
                    </button>
                    <button :class="['tab-btn', { active: activeTab === 'legal' }]" @click="activeTab = 'legal'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                        </svg>
                        Légal
                    </button>
                    <button :class="['tab-btn', { active: activeTab === 'config' }]" @click="activeTab = 'config'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                        </svg>
                        Caisse
                    </button>
                </div>

                <form @submit.prevent="submitForm">
                    <!-- Onglet Informations générales -->
                    <div v-show="activeTab === 'general'" class="tab-content">

                        <div class="form-group">
                            <label for="companyName">Nom de l'entreprise *</label>
                            <input type="text" id="companyName" v-model="form.name" required
                                placeholder="Nom de votre entreprise" :class="{ 'error': errors.name }" />
                            <span v-if="errors.name" class="error-message">{{ errors.name[0] }}</span>
                        </div>

                        <div class="form-group">
                            <label for="businessType">Type d'activité</label>
                            <input type="text" id="businessType" v-model="form.business_type"
                                placeholder="Ex: Commerce de détail, Services..."
                                :class="{ 'error': errors.business_type }" />
                            <span v-if="errors.business_type" class="error-message">{{ errors.business_type[0] }}</span>
                        </div>

                        <div class="form-group">
                            <label for="description">Description</label>
                            <textarea id="description" v-model="form.description"
                                placeholder="Décrivez votre entreprise..." rows="3"
                                :class="{ 'error': errors.description }"></textarea>
                            <span v-if="errors.description" class="error-message">{{ errors.description[0] }}</span>
                        </div>
                    </div>

                    <!-- Onglet Contact -->
                    <div v-show="activeTab === 'contact'" class="tab-content">
                        <div class="form-row">
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" id="email" v-model="form.email" placeholder="contact@entreprise.com"
                                    :class="{ 'error': errors.email }" />
                                <span v-if="errors.email" class="error-message">{{ errors.email[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="phone">Téléphone</label>
                                <input type="tel" id="phone" v-model="form.phone" placeholder="+221 77 123 45 67"
                                    :class="{ 'error': errors.phone }" />
                                <span v-if="errors.phone" class="error-message">{{ errors.phone[0] }}</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="website">Site web</label>
                            <input type="url" id="website" v-model="form.website"
                                placeholder="https://www.entreprise.com" :class="{ 'error': errors.website }" />
                            <span v-if="errors.website" class="error-message">{{ errors.website[0] }}</span>
                        </div>

                        <div class="form-divider">
                            <span>Adresse</span>
                        </div>

                        <div class="form-group">
                            <label for="address">Adresse</label>
                            <input type="text" id="address" v-model="form.address"
                                placeholder="Rue, numéro, quartier..." :class="{ 'error': errors.address }" />
                            <span v-if="errors.address" class="error-message">{{ errors.address[0] }}</span>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label for="city">Ville</label>
                                <input type="text" id="city" v-model="form.city" placeholder="Dakar"
                                    :class="{ 'error': errors.city }" />
                                <span v-if="errors.city" class="error-message">{{ errors.city[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="country">Pays</label>
                                <input type="text" id="country" v-model="form.country" placeholder="Sénégal"
                                    :class="{ 'error': errors.country }" />
                                <span v-if="errors.country" class="error-message">{{ errors.country[0] }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Onglet Informations légales -->
                    <div v-show="activeTab === 'legal'" class="tab-content">
                        <div class="form-row">
                            <div class="form-group">
                                <label for="ninea">NINEA</label>
                                <input type="text" id="ninea" v-model="form.ninea" placeholder="Numéro NINEA"
                                    :class="{ 'error': errors.ninea }" />
                                <span v-if="errors.ninea" class="error-message">{{ errors.ninea[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="rccm">RCCM</label>
                                <input type="text" id="rccm" v-model="form.rccm" placeholder="Registre du commerce"
                                    :class="{ 'error': errors.rccm }" />
                                <span v-if="errors.rccm" class="error-message">{{ errors.rccm[0] }}</span>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label for="taxId">Numéro fiscal</label>
                                <input type="text" id="taxId" v-model="form.tax_id"
                                    placeholder="Numéro d'identification fiscale" :class="{ 'error': errors.tax_id }" />
                                <span v-if="errors.tax_id" class="error-message">{{ errors.tax_id[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="capital">Capital</label>
                                <input type="number" id="capital" v-model.number="form.capital"
                                    placeholder="Capital social" min="0" :class="{ 'error': errors.capital }" />
                                <span v-if="errors.capital" class="error-message">{{ errors.capital[0] }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Onglet Configuration caisse -->
                    <div v-show="activeTab === 'config'" class="tab-content">
                        <div class="form-group">
                            <label for="currency">Devise</label>
                            <select id="currency" v-model="form.currency" :class="{ 'error': errors.currency }">
                                <option value="XOF">XOF - Franc CFA (FCFA)</option>
                                <option value="EUR">EUR - Euro (€)</option>
                                <option value="USD">USD - Dollar ($)</option>
                                <option value="GBP">GBP - Livre Sterling (£)</option>
                            </select>
                            <span v-if="errors.currency" class="error-message">{{ errors.currency[0] }}</span>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label for="startBalance">Solde de départ caisse</label>
                                <input type="number" id="startBalance" v-model.number="form.cash_register_start_balance"
                                    placeholder="0" min="0" :class="{ 'error': errors.cash_register_start_balance }" />
                                <span v-if="errors.cash_register_start_balance" class="error-message">{{
                                    errors.cash_register_start_balance[0] }}</span>
                            </div>
                            <div class="form-group">
                                <label for="maxRegisters">Nombre max de caisses</label>
                                <input type="number" id="maxRegisters" v-model.number="form.max_cash_registers"
                                    placeholder="Illimité si vide" min="1"
                                    :class="{ 'error': errors.max_cash_registers }" />
                                <span class="field-hint">Laisser vide pour illimité</span>
                                <span v-if="errors.max_cash_registers" class="error-message">{{
                                    errors.max_cash_registers[0] }}</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="cancel-btn" @click="$emit('close')">Annuler</button>
                <button type="button" class="confirm-btn" @click="submitForm" :disabled="isSubmitting">
                    <span v-if="isSubmitting" class="spinner-small"></span>
                    <span>{{ isSubmitting ? 'Enregistrement...' : 'Enregistrer' }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, reactive, watch } from 'vue';
import companyService from '@/services/companyService';

export default defineComponent({
    name: 'EditCompanyModal',

    props: {
        show: {
            type: Boolean,
            default: false
        },
        company: {
            type: Object,
            default: null
        }
    },

    emits: ['close', 'company-updated'],

    setup(props, { emit }) {
        const activeTab = ref('general');
        const isSubmitting = ref(false);
        const errors = reactive({});
        const logoInput = ref(null);
        const logoPreview = ref(null);
        const logoFile = ref(null);
        const removeExistingLogo = ref(false);

        // Formulaire
        const form = reactive({
            name: '',
            business_type: '',
            description: '',
            email: '',
            phone: '',
            website: '',
            address: '',
            city: '',
            country: '',
            ninea: '',
            rccm: '',
            tax_id: '',
            capital: null,
            currency: 'XOF',
            cash_register_start_balance: null,
            max_cash_registers: null
        });

        // Charger les données quand le modal s'ouvre
        watch(() => props.show, (newVal) => {
            if (newVal && props.company) {
                populateForm();
            }
        });

        watch(() => props.company, (newVal) => {
            if (props.show && newVal) {
                populateForm();
            }
        });

        const populateForm = () => {
            const c = props.company;
            if (!c) return;

            form.name = c.name || '';
            form.business_type = c.business_type || '';
            form.description = c.description || '';
            form.email = c.email || '';
            form.phone = c.phone || '';
            form.website = c.website || '';
            form.address = c.address || '';
            form.city = c.city || '';
            form.country = c.country || '';
            form.ninea = c.ninea || '';
            form.rccm = c.rccm || '';
            form.tax_id = c.tax_id || '';
            form.capital = c.capital || null;
            form.currency = c.currency || 'XOF';
            form.cash_register_start_balance = c.cash_register_start_balance ?? null;
            form.max_cash_registers = c.max_cash_registers ?? null;

            // Charger le logo existant
            logoPreview.value = c.logo || null;
            logoFile.value = null;
            removeExistingLogo.value = false;

            // Reset errors et tab
            Object.keys(errors).forEach(key => delete errors[key]);
            activeTab.value = 'general';
        };

        // Gestion du logo
        const triggerLogoInput = () => {
            logoInput.value?.click();
        };

        const onLogoSelected = (event) => {
            const file = event.target.files?.[0];
            if (file) {
                handleLogoFile(file);
            }
        };

        const onDragOver = (event) => {
            event.currentTarget.classList.add('drag-over');
        };

        const onDragLeave = (event) => {
            event.currentTarget.classList.remove('drag-over');
        };

        const onLogoDrop = (event) => {
            event.currentTarget.classList.remove('drag-over');
            const file = event.dataTransfer.files?.[0];
            if (file && file.type.startsWith('image/')) {
                handleLogoFile(file);
            }
        };

        const handleLogoFile = (file) => {
            // Validation taille (2MB max)
            if (file.size > 2 * 1024 * 1024) {
                errors.logo = ['Le fichier ne doit pas dépasser 2MB'];
                return;
            }

            // Validation type
            if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
                errors.logo = ['Le fichier doit être une image JPG ou PNG'];
                return;
            }

            delete errors.logo;
            logoFile.value = file;
            removeExistingLogo.value = false;

            // Créer preview
            const reader = new FileReader();
            reader.onload = (e) => {
                logoPreview.value = e.target.result;
            };
            reader.readAsDataURL(file);
        };

        const removeLogo = () => {
            logoFile.value = null;
            logoPreview.value = null;
            removeExistingLogo.value = true;
            if (logoInput.value) {
                logoInput.value.value = '';
            }
        };

        // Soumission du formulaire
        const submitForm = async () => {
            if (isSubmitting.value) return;

            // Validation côté client
            if (!form.name.trim()) {
                errors.name = ['Le nom de l\'entreprise est requis'];
                activeTab.value = 'general';
                return;
            }

            isSubmitting.value = true;
            Object.keys(errors).forEach(key => delete errors[key]);

            try {
                // Préparer les données
                const companyData = {
                    name: form.name,
                    business_type: form.business_type || null,
                    description: form.description || null,
                    email: form.email || null,
                    phone: form.phone || null,
                    website: form.website || null,
                    address: form.address || null,
                    city: form.city || null,
                    country: form.country || null,
                    ninea: form.ninea || null,
                    rccm: form.rccm || null,
                    tax_id: form.tax_id || null,
                    capital: form.capital || null,
                    currency: form.currency,
                    cash_register_start_balance: form.cash_register_start_balance ?? null,
                    max_cash_registers: form.max_cash_registers || null
                };

                // Ajouter le nouveau logo si sélectionné
                if (logoFile.value) {
                    companyData.logo = logoFile.value;
                }

                // Mettre à jour l'entreprise
                const response = await companyService.updateCompany(props.company.id, companyData);

                // Si on veut supprimer le logo existant (sans nouveau logo)
                if (removeExistingLogo.value && !logoFile.value && props.company.logo) {
                    try {
                        await companyService.deleteLogo(props.company.id);
                    } catch (e) {
                        console.warn('Erreur lors de la suppression du logo:', e);
                    }
                }

                // Mettre à jour le localStorage
                const updatedCompany = response.data.company || response.data;
                localStorage.setItem('company', JSON.stringify(updatedCompany));

                emit('company-updated', updatedCompany);
                emit('close');
            } catch (error) {
                console.error('Erreur lors de la mise à jour:', error);

                if (error.response && error.response.status === 422) {
                    const validationErrors = error.response.data.errors || {};
                    Object.keys(validationErrors).forEach(key => {
                        errors[key] = validationErrors[key];
                    });

                    // Naviguer vers l'onglet avec l'erreur
                    const errorKeys = Object.keys(validationErrors);
                    if (errorKeys.some(k => ['name', 'business_type', 'description', 'logo'].includes(k))) {
                        activeTab.value = 'general';
                    } else if (errorKeys.some(k => ['email', 'phone', 'website', 'address', 'city', 'country'].includes(k))) {
                        activeTab.value = 'contact';
                    } else if (errorKeys.some(k => ['ninea', 'rccm', 'tax_id', 'capital'].includes(k))) {
                        activeTab.value = 'legal';
                    } else if (errorKeys.some(k => ['currency', 'cash_register_start_balance', 'max_cash_registers'].includes(k))) {
                        activeTab.value = 'config';
                    }
                } else {
                    alert('Une erreur est survenue lors de la mise à jour');
                }
            } finally {
                isSubmitting.value = false;
            }
        };

        return {
            activeTab,
            form,
            errors,
            isSubmitting,
            logoInput,
            logoPreview,
            triggerLogoInput,
            onLogoSelected,
            onDragOver,
            onDragLeave,
            onLogoDrop,
            removeLogo,
            submitForm
        };
    }
});
</script>

<style scoped>
/* Modal de base */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    padding: 20px;
}

.modal-container {
    width: 100%;
    max-width: 700px;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    animation: modal-appear 0.3s ease-out;
}

@keyframes modal-appear {
    from {
        opacity: 0;
        transform: translateY(40px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.edit-company-modal {
    max-width: 650px;
}

/* En-tête du modal */
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;
    background-color: white;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.modal-header h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #0A5C6B;
}

.close-modal-btn {
    background: none;
    border: none;
    color: #64748b;
    cursor: pointer;
    padding: 6px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.close-modal-btn:hover {
    background-color: #f1f5f9;
    color: #0A5C6B;
}

/* Corps du modal */
.modal-body {
    padding: 0;
    flex: 1;
    overflow-y: auto;
    max-height: calc(90vh - 140px);
}

/* Onglets */
.form-tabs {
    display: flex;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
    padding: 0 12px;
    overflow-x: auto;
}

.tab-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 16px;
    background: none;
    border: none;
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.tab-btn.active {
    color: #0A5C6B;
    border-bottom-color: #0A5C6B;
    background: white;
}

.tab-btn:hover:not(.active) {
    color: #334155;
    background-color: #f1f5f9;
}

.tab-btn svg {
    flex-shrink: 0;
}

/* Contenu des onglets */
.tab-content {
    padding: 24px;
}

/* Logo Upload */
.logo-upload-section {
    margin-bottom: 24px;
}

.section-label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #334155;
    margin-bottom: 10px;
}

.logo-upload-container {
    display: flex;
    justify-content: center;
}

.logo-dropzone {
    width: 150px;
    height: 150px;
    border: 2px dashed #e2e8f0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
    background: #f8fafc;
}

.logo-dropzone:hover {
    border-color: #0A5C6B;
    background: #f1f5f9;
}

.logo-dropzone.drag-over {
    border-color: #0A5C6B;
    background: rgba(10, 92, 107, 0.05);
}

.logo-dropzone.has-logo {
    border-style: solid;
    border-color: #e2e8f0;
}

.logo-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #94a3b8;
    text-align: center;
    padding: 16px;
}

.logo-placeholder svg {
    color: #cbd5e1;
}

.logo-placeholder span {
    font-size: 12px;
}

.logo-placeholder .hint {
    font-size: 11px;
    color: #94a3b8;
}

.logo-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.logo-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.2s ease;
    color: white;
    font-size: 12px;
    font-weight: 500;
}

.logo-dropzone:hover .logo-overlay {
    opacity: 1;
}

.hidden-input {
    display: none;
}

/* Formulaire */
.form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 0;
}

.form-row .form-group {
    flex: 1;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #334155;
    margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: white;
}

.form-group textarea {
    resize: vertical;
    min-height: 80px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
    outline: none;
    border-color: #0A5C6B;
    box-shadow: 0 0 0 3px rgba(10, 92, 107, 0.1);
}

.form-group input.error,
.form-group select.error,
.form-group textarea.error {
    border-color: #ef4444;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
    color: #94a3b8;
}

.error-message {
    display: block;
    color: #ef4444;
    font-size: 12px;
    margin-top: 6px;
}

.field-hint {
    display: block;
    font-size: 12px;
    color: #94a3b8;
    margin-top: 4px;
}

/* Divider */
.form-divider {
    display: flex;
    align-items: center;
    margin: 24px 0;
    gap: 16px;
}

.form-divider::before,
.form-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e2e8f0;
}

.form-divider span {
    font-size: 12px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Pied du modal */
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 24px;
    border-top: 1px solid #e2e8f0;
    background-color: white;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

/* Boutons */
.cancel-btn,
.confirm-btn {
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.cancel-btn {
    background-color: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
}

.cancel-btn:hover {
    background-color: #f8fafc;
}

.confirm-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: #0A5C6B;
    color: white;
    border: none;
    min-width: 140px;
}

.confirm-btn:hover:not(:disabled) {
    background-color: #094854;
}

.confirm-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Spinner */
.spinner-small {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive */
@media (max-width: 640px) {
    .modal-container {
        max-height: 95vh;
        width: 100%;
        margin: 10px;
    }

    .form-tabs {
        padding: 0 8px;
    }

    .tab-btn {
        padding: 12px 10px;
        font-size: 12px;
    }

    .tab-btn svg {
        width: 14px;
        height: 14px;
    }

    .form-row {
        flex-direction: column;
        gap: 0;
    }

    .tab-content {
        padding: 20px 16px;
    }

    .logo-dropzone {
        width: 120px;
        height: 120px;
    }
}
</style>
